module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("THE CREATIVE WORD AS LIFE AND LIGHT"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=John+1%3A2-5&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JOHN 1:2-5")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW: ")])]), _vm._v("If the reader had heard that “the Word was God,” without any further clarification, he might have been led to believe John was contradicting belief in one God; John 1:2, however, clarifies the eternity and divinity of that same Word (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY")]), _vm._v(") while preserving his distinction as a person in the Godhead, coeternal with the Father (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(") as one who has absolute existence (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY")]), _vm._v("). As such, he is still not devoid of a beginning, but he was always coexistent with his beginning (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE")]), _vm._v("). John, in effect, summarizes the first three propositions of John 1:1 in John 1:2 (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). But this is not only a summation; the demonstrative pronoun “this” ensures that his readers will not posit a second Word or deity (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). One may wonder why he does not qualify the Word as well then by calling it the “Word "), _c('i', [_vm._v("of God,")]), _vm._v("” but John omits the qualification here"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN243",
      "id": "ap_NFIN243-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" to show that this Word is not one among many different words but is the Word that encompasses all other words, wisdom and truth (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christ as the Word is the architect of creation; he is Wisdom who resides in the Father’s heart—the wisdom uttered that brought about the act of creation (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUDENTIUS")]), _vm._v("). John here distinguishes this creator from his creation (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE")]), _vm._v("), focusing more on the creator than the creation and thus moving beyond the account of Moses in Genesis (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). His purpose is also to show that the Word itself was not made, since the Word made everything. And, if the Word is not a creature, then it must be of one substance with the Father, since “all substance that is not God is creature, and all that is not creature is God” (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). But some have asked whether the Word is shown to be inferior here since it is only an agent of creation rather than the creator (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). John, however, phrased the Son’s role in this way to prevent anyone from thinking that the Son is the unbegotten one (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). Rather than pitting the persons against one another in the act of creation, it should be clear that creation, as well as all that God does, is a trinitarian activity, the Son being both the Creator and the agent of creation (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("John takes up where Moses left off, encompassing not only the visible creation in the "), _c('i', [_vm._v("all things")]), _vm._v(" of the previous phrase but everything else as well, including invisible things (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). He further qualifies his own earlier statement that “all things were made through him” by adding “without him was nothing made,” thereby drawing out the distinction between the creator and his companion both present at creation"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN244",
      "id": "ap_NFIN244-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY")]), _vm._v("). He is not, however, including sin, wickedness and evil in the realm of created things. These are subsumed under those things that are not, which John here calls “nothing” because they are made without the Word (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). Sin, too, is nothing because it comes about without the Word, and nothing is what we become when we give in to it. But thank God that Christ was willing to make himself nothing, even though he made everything, in order to make us rich in his love (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("John 1:4 can be read in a couple of different ways due to the textual variant “that which was made” being appended to the beginning of verse four or to the end of John 1:3. Verse four then can either be read as, “That which was made in him was life” (H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY")]), _vm._v("), or simply, “In him was life.” Some manipulate the punctuation in an attempt to prove that the Holy Spirit is a creature that was created by the Word (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(") or to emphasize Christ’s creative work at the expense of that of the Father and the Spirit (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). But when the text is read as “That which was made in him was life,” it can also be understood correctly of the Son, who is the life and who gives life to those who believe in him, since no one can live apart from him (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). They were created "), _c('i', [_vm._v("in ")]), _vm._v("him because their design was in him as a concept is in a designer, and they were created "), _c('i', [_vm._v("through ")]), _vm._v("him as he is the agent of creation (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). Either way, the Word is a fountain of life that is never depleted no matter how much it is accessed and "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("that makes possible our resurrection (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). He is the one who brought life to us even as he accepted our death (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). When we receive that life, it also becomes the foundation for the light of knowledge (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The Word of God is not only truly light but is also the giver of light (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). A blind person may be in the presence of the sun so that the sun is present to him, but he is absent from the sun due to his blindness (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). We need not remain in this darkness as though it were a part of our nature that cannot be overcome, however, since Paul proclaims, “You were once darkness, but now you are light” (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). God sometimes gives us darkness as a trial to endure, but he never leaves us there in the dark. Through Christ we emerge into his light stronger for having struggled with the darkness (I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SAAC")]), _vm._v("), knowing that everything is ultimately brought to light by the Lord (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). The light is chased by the darkness as the darkness seeks to overpower the light (G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS")]), _vm._v("). Darkness, however, will not prevail because if God is for us, who can prevail against us (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(")? The text also may be understood to say that the darkness has not comprehended the light because it does not know the creator, nor is it receptive to his radiance (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(").")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("In summary, because of the profound wisdom they offer, these five verses should be engraved in gold in every church (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("1:2 "), _c('i', [_vm._v("This One Was in the Beginning with God")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTRADICTION WITH ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIEF IN ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD. ")])]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS: ")]), _vm._v("But I tremble to say it; the audacity staggers me. I hear, “And the Word was God”—I, who have been taught by the prophets that God is one. To save me from further apprehension, my friend, the fisherman, needs to provide a fuller understanding of this great mystery. Show me that these assertions are consistent with the unity of God; that there is no blasphemy in them, no explaining away, no denial of eternity. And so he continues, “He was in the beginning with God.” This “He was in the beginning” removes the limit of time; the word "), _c('i', [_vm._v("God")]), _vm._v(" shows that he is more than a voice; that “he is "), _c('i', [_vm._v("with")]), _vm._v(" God” proves that he neither encroaches nor is encroached on, for his identity is not swallowed up in that of Another, and he—that is, his one and only begotten Son—is clearly stated to be present with the one unbegotten God as God. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 2.16.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN245",
      "id": "ap_NFIN245-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD’S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OETERNITY WITH THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("As therefore the expression “in the beginning was the Word” shows his eternity, so “was in the beginning with God” has declared to us his coeternity. For, so that you may not think the Word is eternal when you hear “in the beginning was the Word,” but yet imagine the life of the Father to differ from his by some interval and longer duration and thus assign a beginning to the Only Begotten—this is why John adds, “was in the beginning with God.” He exists eternally even as the Father himself does, for the Father was never without the Word, but he was always God with God, yet each in his proper person…. So that no one might suppose the Godhead of the Son to be inferior, he immediately added the characteristics of genuine Godhead, including eternity (for “He was,” says he, “in the beginning with God,”) and attributed to him the office of Creator. For “by him were all things made.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 4.1, 3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN246",
      "id": "ap_NFIN246-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD’S ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BSOLUTE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XISTENCE AND ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERNITY AS ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD. ")])]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS: ")]), _vm._v("The backward straining of our thoughts can never grasp anything prior to God’s property of absolute existence since nothing presents itself to enable us to understand the nature of God, even though we might go on seeking it forever—nothing, that is, except the fact that God always is. That then which has both been declared about God by Moses, that of which our human intelligence can give no further explanation, "), _c('i', [_vm._v("that")]), _vm._v(" [is] "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("the very quality the Gospels testify to be a property of God the only begotten since in the beginning was the Word, and since the Word was with God, and since he was the true Light, and since God the only begotten is in the bosom of the Father,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN247",
      "id": "ap_NFIN247-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" and since Jesus Christ is God over all."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN248",
      "id": "ap_NFIN248-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Therefore he "), _c('i', [_vm._v("was ")]), _vm._v("and he "), _c('i', [_vm._v("is,")]), _vm._v(" since he is from him who always is what he is. But to be from him, that is to say, to be from the Father, is birth. Moreover, to be always from him, who always is, is eternity; but this eternity is derived not from himself but from the Eternal. And from the Eternal nothing can spring but what is eternal: for if the offspring is not eternal, then neither is the Father, who is the source of generation, eternal. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 12.24-25.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN249",
      "id": "ap_NFIN249-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE “")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD” ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LWAYS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEXISTENT WITH ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNING. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("John wanted to persuade by using the name “Word,” as if by an analogy, that it was possible for something to be from something else without having to be separated from it by length of time…. Also, because he said “he was in the beginning,” he showed not that he was without a beginning but rather that he was coexistent from eternity with his beginning. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.1.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN250",
      "id": "ap_NFIN250-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMING ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("After the Evangelist has taught us the three orders through the three propositions that were previously mentioned, he sums up the three under one head, saying, “The same was in the beginning with God.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now we have learned from the three propositions first, in what the Word was, namely, “in the beginning,” and with whom he was, namely, “God,” and who the Word was, namely, “God.” It is as if, therefore, he indicates the previously mentioned God the Word by the expression “the same” and gathers the three, “in the beginning was the Word” and “The Word was with God, and the Word was God,” into a fourth proposition and says, “The same was in the beginning with God.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.34-35.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN251",
      "id": "ap_NFIN251-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("“")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS” ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S AN ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPORTANT ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDITION. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("The Evangelist here makes a sort of recapitulation of what had already been said. But when he adds the word "), _c('i', [_vm._v("this,")]), _vm._v(" he is all but crying aloud, “He who is in the beginning, the Word with the Father, he who is God of God, he it is and no one else who is the subject of this august book.” But he seems again not idly to add to what has been said, “This was in the beginning with God.” For he, enlightened by the divine Spirit about the future, was not ignorant … that certain people would appear,… who would rise up and strive against their own leader, saying that one is the word that is conceived in God the Father, and that the other, who is very similar and like the conceived one, is the Son and Word through whom God works all things. In this way he might be [falsely] conceived of as word of word and image of image and radiance of radiance.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The blessed Evangelist, then, as though he had already heard them blaspheming, and having already defined and shown by many words that the Word is one and only and truly of God and in God and with God—with flashing eye adds, “This was in the beginning with God,” as Son, that is, with the Father, as inborn, as of his [the Father’s] essence, as only begotten—"), _c('i', [_vm._v("this")]), _vm._v(" one, there being no second. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN252",
      "id": "ap_NFIN252-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY “")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("”? ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Someone perhaps may ask with good reason why it was not said, “In the beginning was the Word "), _c('i', [_vm._v("of God,")]), _vm._v(" and the Word "), _c('i', [_vm._v("of God")]), _vm._v(" was with God, and the Word "), _c('i', [_vm._v("of God")]), _vm._v(" was God.” But one who asks this… is proposing that there are many words, and perhaps different kinds of words of which one is the word of God, and another, let us say, is the word of angels, and another the word of people….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For every person imaginable would admit "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("that the truth is one. No one would dare say, in the case of [truth] too, that the truth of God is one thing, and that of the angels is another, and that of people still another. For it belongs to the nature of beings that the truth concerning each is one…. And if truth is one and wisdom is one, the Word also, who announces the truth and wisdom simply and openly to those capable of apprehending it, would be one. And we say these things, not to deny that the truth and wisdom and the Word are of God but to show the advantage of the omission of the phrase “of God.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.37, 39-41.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN253",
      "id": "ap_NFIN253-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:3a "), _c('i', [_vm._v("All Things Were Made by Him")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATING ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILE IN THE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSOM OF THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER. ")])]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUDENTIUS:")])]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("Though you came from the mouth of God,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Born as his Word on earth below,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Yet as his Wisdom you lived")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Forever in the Father’s heart.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("This Wisdom uttered made the sky,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("The sky and light and all besides;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN254",
      "id": "ap_NFIN254-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("All by the Word’s almighty power")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Were fashioned, for the Word was God.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("But when the universe was formed")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("And ordered by unchanging laws,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("The Cause and architect divine")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("In the Father’s bosom still remained,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN255",
      "id": "ap_NFIN255-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Until the slow revolving years")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("In centuries at length had passed,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN256",
      "id": "ap_NFIN256-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("And he himself condescended to come")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Down to the world grown old in sin….")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("But such destruction of humankind")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("The heart of Christ could not endure;")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("And lest his Father’s handiwork,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Unvindicated, should be lost,")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("He clothed himself in mortal flesh,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("That by arising from the tomb")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("He might unlock the chains of death")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("And bring man to his Father’s house.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("This is your natal day, on which")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("The high Creator sent you forth,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN257",
      "id": "ap_NFIN257-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("And gave to you a form of clay,")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Uniting flesh with his own Word.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YMNS FOR ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERY ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY 11, ")]), _vm._v("A H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YMN FOR ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTMAS ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN258",
      "id": "ap_NFIN258-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPARED WITH ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATED ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINGS. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Intending to make the divinity of the Only Begotten clearer, [the Evangelist] wanted to show the difference [of the Son] not only by indicating his dignity but also by demonstrating that he has no participation with the created order. He says, “[The Word] was with God in the beginning,” and “All things were made through him.” By saying this, he has opposed"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN259",
      "id": "ap_NFIN259-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" himself to “all things made.” He was, he says, in the beginning with God, all creatures were made through him. And clearly he made a comparison with “in the beginning was,” and its opposite, “all things were made through him.” Therefore he was not made, because in the beginning he was; they "), _c('i', [_vm._v("were")]), _vm._v(" made because they did not exist before. He himself is the explanation of the precedents. He shows what he means through the words “In the beginning was,” clearly asserting his eternity. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.1.2-3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN260",
      "id": "ap_NFIN260-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVES ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EYOND ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES AND ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATION TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATOR. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Moses in the beginning of the history and writings of the Old Testament speaks to us of the objects of sense and enumerates them to us at length. For “in the beginning,” he says, “God made the heaven and the earth,” and then he adds that light was created, and a second heaven and the stars, the various kinds of living creatures, and (that we "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("may not delay by going through particulars) everything else. But this Evangelist, cutting to the quick, includes both these things and the things that are above these in a single sentence. He does this because they were known to his hearers and because he is hurrying on to a greater subject. His treatise is not so much about the works as about the Creator and him who produced them all. And therefore Moses, though he has selected the smaller portion of the creation (for he has spoken nothing to us concerning the invisible powers), dwells on these things;")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN261",
      "id": "ap_NFIN261-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" while John, as hurrying to ascend to the Creator himself, passes over both of these things and those on which Moses was silent, having comprised them in one little saying: “All things were made by him.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN262",
      "id": "ap_NFIN262-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Let someone of the unbelieving Arians come forward now and say that the Word of God was made."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN263",
      "id": "ap_NFIN263-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" How can it happen that the Word of God was made when God made all things through the Word? If even the Word of God itself was made, through what other Word was it made? If you say that there is a Word of the Word, through which that [Word] was made, I say that this itself is the only Son of God. If you deny there is a Word of the Word, grant that that through which all things were made was itself not made. For that through which all things were made could not be made through itself. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTATES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.11.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN264",
      "id": "ap_NFIN264-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S OF ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBSTANCE WITH THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("And if he was not made, then he is not a creature; but if he is not a creature, then he is of the same substance with the Father. For all substance that is not God is creature, and all that is not creature is God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN265",
      "id": "ap_NFIN265-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" And if the Son is not of the same substance with the Father, then he is a substance that was made; and if he is a substance that was made, then all things were not made by him; but “all things were made by him,” therefore he is of one and the same substance with the Father. And so, he is not only God but also very God. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 1.6 [9].")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN266",
      "id": "ap_NFIN266-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY AN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GENT OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATION? ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("The fact that “all things were made "), _c('i', [_vm._v("through")]), _vm._v(" him,” will not, I think, cause any damage concerning what is said about the Son. For the Son is not introduced here as an employee or servant of someone else’s will just because it says that the things that exist were made "), _c('i', [_vm._v("through")]), _vm._v(" him, implying that he should be no longer conceived of as being by nature Creator. Nor is he someone who was given the power of creation by someone else, but rather being himself alone the strength of God the Father, as Son, as only begotten, he works all things, the Father and the Holy Spirit co-working and coexisting with him. For all things are from the Father through the Son in the Holy Spirit. And we conceive of the Father as coexisting with the Son, not as though he were powerless to bring anything into existence but rather as one who is wholly in [the Son] because of the unchangeableness of essence. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN267",
      "id": "ap_NFIN267-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD “")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH”")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN268",
      "id": "ap_NFIN268-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _c('b', [_vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERLY ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERPLEX ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul, inspired by the same grace, said, “For by him were all things created.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN269",
      "id": "ap_NFIN269-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v("… But if you think that the expression “through” is a mark of inferiority (as making Christ an instrument), listen to what [David] says: “You, Lord, in the beginning, have laid the foundation of the earth, and the heavens are the work of your hands.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN270",
      "id": "ap_NFIN270-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" He says of the Son what is said of the Father in his character of "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Creator. This is something he would not have said unless he had thought of him as he thought of a Creator and yet not subservient to any. And if the expression “through him” is used here, it is for no other reason than to prevent anyone from thinking that Son is unbegotten. For listen to Christ himself tell how, with respect to the title of Creator, he is nothing inferior to the Father: “As the Father raises up the dead and quickens them, even so the Son quickens whom he will.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN271",
      "id": "ap_NFIN271-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" If now in the Old Testament it is said of the Son, “You, Lord, in the beginning have laid the foundation of the earth,” his title of Creator is plain. But if you say that the prophet spoke this of the Father and that Paul attributed to the Son what was said of the Father, even so the conclusion is the same. For Paul would not have decided that the same expression suited the Son, unless he had been very confident that between Father and Son there was an equality of honor. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN272",
      "id": "ap_NFIN272-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S BY ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPARATED FROM THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHER. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("He himself who calls the Son of God the maker even of heavenly things has also plainly said that all things were made in the Son, that in the renewal of his works he might by no means separate the Son from the Father but unite him to the Father. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT 3.11.83.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN273",
      "id": "ap_NFIN273-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:3b "), _c('i', [_vm._v("Without Him Was Nothing Made")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINGS ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISIBLE OR ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVISIBLE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATED BY ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("And that you may not think that he merely speaks of all the things mentioned by Moses, he adds that “without him was not anything made that was made.” That is to say, that of created things, not one—whether it be visible or intelligible—was brought into being without the power of the Son. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN274",
      "id": "ap_NFIN274-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTINCTION ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETWEEN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATOR AND ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPANION. ")])]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS: ")]), _vm._v("“All things were made through him” needs qualification. There is the Unbegotten who no one made; there is also the Son, begotten of the unborn Father. “All things” is an unguarded statement, admitting no exceptions. While we are silent, not daring to answer or trying to think of some reply, you [John] break in with, “And without him was nothing made.” You have restored the author of the Godhead to his place while proclaiming that he has a companion. From your saying that nothing was made “without him,” I learn that he was not alone. He through whom the work was done is one; he without whom it was not done is another: a distinction is drawn between Creator and Companion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Reverence for the one unbegotten Creator distressed me, lest in your sweeping assertion that all things were made by the Word you had included him. You have banished my fears by your “without him was nothing made.” Yet this same “without him was nothing made” brings its own trouble and distraction. There was, then, something made by that other; not made, it is true, “without him.” If the other did make anything, even if the Word were present at the making, then it is untrue that “through him all things were made.” It is one thing to be the Creator’s Companion, quite another to be the Creator’s self. I could find answers of my own to the previous objections; in this case, fisherman, I can only turn at once to your words, “All things were made through him.” And now I understand, for the apostle has enlightened me with these words: “Things visible and things invisible, whether thrones or dominions or principalities or powers, all are “through” him and “in him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN275",
      "id": "ap_NFIN275-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 2.18-19.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN276",
      "id": "ap_NFIN276-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY ")]), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH ")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("BUT ")]), _c('i', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v(" THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Now let us see why the statement “And without him was not anything made” is added. Some might think it superfluous to subjoin “without him was not anything made” to “all things were made through him.” For if every conceivable thing has been made “through the Word,” nothing has been made “without the Word.” That all things have been made "), _c('i', [_vm._v("through")]), _vm._v(" the Word, however, does not now follow from the assertion that nothing has been made without the Word. It is possible that not only have all things been made "), _c('i', [_vm._v("through")]), _vm._v(" the Word but also that some things have been made "), _c('i', [_vm._v("by")]), _vm._v(" the Word.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("We must know, therefore, how the expression “all things” is to be understood and how “nothing” should be understood. For it is possible, if both expressions have not been made clear, to take it to mean that if all things were made through the Word, and evil and all the profusion of sin and wickedness belong to the “all things,” that these too, were made through the Word. But this is a false conclusion. For… it is not surprising that all creatures have been made through the Word… but this does not now follow also for acts of sin and falling away. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.91-92.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN277",
      "id": "ap_NFIN277-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT-")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EING AND ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YNONYMS. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("So far as the meaning of “nothing” and “not being” are concerned, they will appear to be synonyms. “Not being” would be meant by “nothing,” and “nothing” by “not being.” The apostle indeed appears to use the expression “those things that are not” not for things that exist nowhere but for things that are wicked, considering “those things that are not” to be things that are bad. For he says, “God called those things that are not as those that are.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN278",
      "id": "ap_NFIN278-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v("… “Not being” and “nothing” are synonyms, and for this reason those “who are not” are “nothing,” and all evil is “nothing,” since it too is “not being.” And evil, which is called “nothing,” has been made without the Word, not being included in “all things.” We have presented then to the best of our ability, what the “all things” are that have been made through the Word, and what that is which was made without him, and, because it never was, is also for this reason called “nothing.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.94, 99.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN279",
      "id": "ap_NFIN279-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMAN ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EINGS ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOME ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Certainly sin was not made through him, and it is clear that sin is nothing and that human beings become nothing when they sin. And an idol was not made through the Word. Indeed an idol has a certain shape, but humankind has been made through the Word. For the form of humanity in the idol was not made through the Word. And it has been written, “We know that an idol is nothing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN280",
      "id": "ap_NFIN280-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" These things, then, were not made through the Word; but whatever things were made through the agency of nature, whatever exist in creation, all things of all kinds whatsoever—from the angel to the grubworm—[these are what were made by the Word]. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTATES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.13.1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN281",
      "id": "ap_NFIN281-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST, THE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKER OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL, ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODEL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHENTIC ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVERTY.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("We have found the genuine poor person. We have found him to be kind and humble, not trusting in himself, truly poor, a member of the poor man, who became poor for our sake, though he was rich. Look at this rich man of ours, who “for our sake became poor, though he was rich;”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN282",
      "id": "ap_NFIN282-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" see how rich he is: “All things were made through him, and without him was made nothing.” There is more to making gold than to having it. You are rich in gold, silver, flocks, household, farms, produce; you were unable to create these things for yourself, though. See how rich he is: “All things were made though him.” See how poor he is: “The Word became flesh and dwelt among us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN283",
      "id": "ap_NFIN283-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Who can fittingly reflect on his riches, how he makes and is not made, how he creates and is not created, is not formed but forms, forms changeable "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("things while changelessly abiding ephemeral things while he himself is everlasting? Who can fittingly ponder his riches? Let us ponder his poverty instead, in case being poor ourselves we may just be able to grasp it. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 14.9.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN284",
      "id": "ap_NFIN284-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:4a "), _c('i', [_vm._v("In Him Was Life")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LWAYS ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE. ")])]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILARY OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OITIERS: ")]), _vm._v("Since then, all things were made through him, come to our help and tell us what it was that was made not without him."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN285",
      "id": "ap_NFIN285-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" “That which was made in him is life.” That which was "), _c('i', [_vm._v("in him ")]), _vm._v("was certainly not made "), _c('i', [_vm._v("without him,")]), _vm._v(" for that which was made in him was also made "), _c('i', [_vm._v("through him.")]), _vm._v(" All things were created in him and through him. They were created in him,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN286",
      "id": "ap_NFIN286-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" for he was born as God the Creator. Again, nothing that was made in him was made without him, for the reason that God the begotten was life and was born as life, not made life after his birth; for there are not two elements in him, one inborn and one afterwards conferred. There is no interval in his case between birth and maturity. None of the things that were created in him was made without him, for he is the life that made their creation possible. Moreover God, the Son of God, became God by virtue of his birth, not after he was born. Being born the Living from the Living, the True from the True, the Perfect from the Perfect, he was born in full possession of his powers. He did not need to learn in the time that followed what his birth was, but was conscious of his Godhead by the very fact that he was born as God of God. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY 2.20.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN287",
      "id": "ap_NFIN287-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUDED IN ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATED. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("We will not put the break at “without him was not any thing made,” as the heretics do. For they are trying to prove the Holy Spirit is a creature and so read, “That which was made in him was life.” But this cannot be so understood. For first of all, this was not the place for mentioning the Holy Spirit…. But let us suppose it was; let us take the passage for the present according to their reading, and we shall see that it leads to a difficulty. For when it is said, “That which was made in him was life,” they say the life spoken of is the Spirit. But this life is also light, for the Evangelist proceeds, “The life was the light of men [humankind].” And so, according to them, “light of men” here means the Spirit…. But the Word mentioned above is what he here calls consecutively God and life and light. If now this Word was life and if this Word and the life became flesh… it follows that the Spirit is incarnate, not the Son….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Dismissing then this reading, we adopt a more suitable one, with the following meaning: “All things were made "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("by him, and without him was not any thing made that was made.” There we make a break and begin a fresh sentence: “In him was life. Without him was not any thing made which was as made,” that is, that could be made. You see how by this short addition he removes any difficulty that might follow. For by introducing “without him was not any thing made” and adding “which was made,” he includes all things invisible but excludes the Spirit…. For the Spirit is uncreated. Do you see the precision of his teaching? H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.1-2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN288",
      "id": "ap_NFIN288-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVOLVED IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATION. ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("Many read this inaccurately because they add without any punctuation, “that which has been made in him was life.” The correct statement is “All things were made through him, and without him was made nothing that has been made,” meaning that that which has been made without him has not been made."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN289",
      "id": "ap_NFIN289-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v("… Now, if all things were made through him, is the Father, on that account, excluded from creation, or Holy Spirit, and has the Son alone worked? Because the Evangelist had said, “All things were made through him,” lest he take away creation from the Holy Spirit and the Father, he added, “And without him was made nothing that has been made.” When he says, “without him was made nothing,” he reveals that another has made but has made nothing without him. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 87, ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1:1-14.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN290",
      "id": "ap_NFIN290-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Our Savior is said to be some things not for himself but for others; others again, both for himself and others…. When it is said then, “That which was made in him was life”… we must inquire whether the life is for himself and others or for others only; and if for others, for whom? Now the Life and the Light are both the same person: he is “the light of men [humanity]”; he is therefore their life. The Savior is called Life here, not to himself but to others whose Light he also is….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This life is inseparable from the Word, from the time it is added on to it. For Reason or the Word must exist before in the soul, cleansing it from sin, till it is pure enough to receive the life, which is thus engrafted or inborn in everyone who renders himself fit to receive the Word of God. And so, observe… that though the Word itself in the beginning was not made—the beginning never having been without the Word—yet the life of people was not always in the Word. This life of people was "), _c('i', [_vm._v("made")]), _vm._v(" in the sense that it was the light of people. And this light of people could not be before humankind was; the light of people being understood relatively to people….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And therefore he says, “that which was made in the Word was life,” and not “that which was in the Word was life.” Some copies read, and perhaps not without credibility, “that which was made, in him is life.” If we understand the life in the Word, to be he who says below, “I am the life,” we shall confess that none who believe not in Christ live, and that all who live not in God, are dead. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.128-32.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN291",
      "id": "ap_NFIN291-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVING ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINGS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBSIST IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("But how were all things made by him? “That, which was made, in him is life.” It can also be read, “That, which was made in him, is life,” and if we read it this way, everything is life. For what is there that was not made in him? For he is the wisdom of God, and it is said in the psalm, “In Wisdom you have made all things.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN292",
      "id": "ap_NFIN292-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" If then Christ is the wisdom of God, and the psalm says, “In wisdom you have made all things,” since all things were made "), _c('i', [_vm._v("by")]), _vm._v(" him all things were also made "), _c('i', [_vm._v("in")]), _vm._v(" him. If, then, all things were made in him, dearly beloved brothers, and that, which was made in him, is life, both the earth is life and wood is life. We do indeed say wood is life, but in the sense of the wood of the cross from which we have received life. A stone, then, is life. But this is an unseemly way to read this passage…. Rather, read it this way: “That which was made;” here make a short pause and then go on, “in him is life.” What is the meaning of this? The earth was made, but the very earth that was made is not life; but there exists spiritually in the wisdom itself a certain reason by which the earth was made: this [reason] is life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As far as I can, I shall explain my meaning to you, beloved. A carpenter makes a box. First he has the box in design; for if he had it not in design, how could he produce it by workmanship? But the box in theory is not the very box as it appears to the eyes. It exists invisibly in design; it will be visible in the work. Behold, it is made in the work; has it ceased to exist in design? The one is made in the work, and the other remains that exists in design; for that box may rot and another be fashioned according to that which exists in design. Listen, then, to the box as it is in design and the box as it is in fact; the actual box is not life, the box in design is life; because the soul of the artificer, where all these things are before they are brought forth, is living. So, dearly beloved brothers, because the wisdom of God, by which all things have been made, contains every"), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("thing according to design before it is made, therefore those things that are made through this design itself are not immediately life, but whatever has been made is life in him. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTATES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.16-17.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN293",
      "id": "ap_NFIN293-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTAIN OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("John spoke of the work of creation, that “all things were made by him, and without him was not anything made that was made.” And so now he goes on to speak concerning his providence, where he says, “In him was life.” That no one may doubt how so many and so great things were “made by him,” he adds, “In him was life.” For as [it is] with the fountain, which is the mother of the great deeps—however much you take away, you do not lessen the fountain—so [it is] with the energy of the Only Begotten. However much you believe has been produced and made by it, it has not diminished. Or, to use a more familiar example, I will use the instance of light, which the apostle himself added immediately, saying, “And the life was the light.” Light, however many millions of times it may enlighten, suffers no diminution of its own brightness. In the same way also God, before commencing his work and after completing it, remains alike indefectible, undiminished, unwearied by the greatness of the creation. No, if it were necessary that ten thousand or even an infinite number of such worlds were created, he still remains the same, sufficient for them all not merely to produce but also to control them after their creation. For the word "), _c('i', [_vm._v("life")]), _vm._v(" here refers not merely to the act of creation but also to the providence engaged in maintaining the things created. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN294",
      "id": "ap_NFIN294-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKLINGS OF THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESURRECTION. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("It also lays down beforehand the doctrine of the resurrection and is the beginning of these marvelous good tidings, since when “life” has come to be with us, the power of death is dissolved; and when “light” has shone upon us, there is no longer darkness, but life always remains within us, and death cannot overcome it. So that what is asserted of the Father might be asserted absolutely of [Christ] also, that “in him we live and move and have our being.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN295",
      "id": "ap_NFIN295-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" As Paul has shown when he says, “By him were all things created” and “by him all things consist.” Thus, [Christ] has been called also “root” and “foundation.” H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 5.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN296",
      "id": "ap_NFIN296-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:4b "), _c('i', [_vm._v("The Life Was the Light")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUGHT ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE TO ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("From where do we get life, from where does he get death? Just look at him: “In the beginning was the Word, and the Word was with God, and the Word was God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN297",
      "id": "ap_NFIN297-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Look for death there. Where? Where from? What sort of Word? The Word with God, the Word that was God. If you can find flesh and blood there, you can find death. So where did death come from for that Word? On the other hand, where did life come from for us human beings, stuck on the earth, mortal, perishable, sinners? He had nothing where he could get death from; we had nothing where we could get life from. He accepted death from what was ours, in order to give us life from what was his. How did he get death from what was ours? “The Word became flesh and dwelt among us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN298",
      "id": "ap_NFIN298-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" He accepted from us here what he would offer for us. And where did life come from for us? “And the life was the light of men.” He was life for us; we were death for him. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 232.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN299",
      "id": "ap_NFIN299-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLIGHTENMENT. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Let us not fail to notice that while it could have been written, “What was made in him was the light of men, and the light of men was life,” John has done the reverse. For he places “the life” before the “light of men,” although “life” and “light of men” are the same….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Why isn’t the “Word” said to be the “light of "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("men,” instead of the “life” that was made in the Word?… The “life” mentioned there is not that life that makes both rational and irrational beings [alive]. It is instead the life that is added to the Word, which is completed in us when a share from the first Word is received. And so, when we turn away from what seems to be life but really is not and we yearn to truly possess life—that is when we first share in it. Once this [kind of] life exists in us, it also becomes the foundation of the light of knowledge.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("And perhaps this life is light potentially (and not actually) for those who really do not want to learn, but with others it becomes light also in actuality. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.153, 156-57.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN300",
      "id": "ap_NFIN300-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:5a "), _c('i', [_vm._v("The Light Shines in the Darkness")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT AND ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVER OF ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("The most wise Evangelist now expands the thought expressed above…. Not only is the Word of God indeed truly light, but he is also the giver of light to all whom he infuses with the light of understanding. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN301",
      "id": "ap_NFIN301-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSON ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANNOT ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EE THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UN’S ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("But perhaps the foolish hearts cannot receive that light because they are so encumbered with sins that they cannot see it. Let them not on that account think that the light is in any way absent, because they are not able to see it. For they, because of their sins, are darkness…. For suppose, as in the case of a blind person placed in the sun, the sun is present to him, but he is absent from the sun. This is how every foolish person, every unjust person, every irreligious person is blind in heart. Wisdom is present, but it is present to a blind person and is absent from his eyes; not because it is absent from him but because he is absent from it. What then is he to do? Let him become pure, that he may be able to see God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN302",
      "id": "ap_NFIN302-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTATES ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.19.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN303",
      "id": "ap_NFIN303-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT AN ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RREVOCABLE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART OF ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURE. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("People are not [darkness] by nature, since Paul says, “For we were once darkness but now are light in the Lord,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN304",
      "id": "ap_NFIN304-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" and this is especially the case if we are now called saints and spiritual. Just as Paul, although he was darkness, became capable of becoming light in the Lord, so may anyone who was once darkness. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.134.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN305",
      "id": "ap_NFIN305-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERCOMES ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISON OF ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS. ")])]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SAAC OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INEVEH: ")]), _vm._v("Let us not be troubled when we are plunged into darkness, especially if we are not the cause of it ourselves. For this darkness is brought about by divine providence for reasons that are known only to God. Our soul becomes suffocated and placed, as it were, in the middle of a storm system. Even if someone tries to approach Scripture—or whatever he approaches, it is only darkness on darkness that he finds instead that causes him to give up. How often is it that he is not even allowed to approach. He is totally incapable of believing that any other possibilities are out there that might give him some peace again. It is an hour filled with despair and fear! The soul is utterly deprived of hope in God and the consolation of faith. It is entirely filled with doubt and fear.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But those who have been tested by the distress of such an hour know that in the end it is followed by a change. God never leaves the soul for a whole day in such a state, otherwise it would lose life and all Christian hope…. Rather, he allows it to emerge very soon from the darkness. Blessed is he who endures such temptations. For, as the Fathers say, great will be the stability and the strength to which he will come after that. This struggle will not be over all at once, however; neither will grace come and dwell in the soul completely at once, but gradually. After grace, the trial returns. Sometimes there is temptation, sometimes consolation…. We do not expect complete deliverance from it here, nor do we expect complete consolation. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCETICAL ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 48.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN306",
      "id": "ap_NFIN306-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("1:5b "), _c('i', [_vm._v("Darkness Does Not Overcome Light")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REVENT ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT FROM ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EING ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("The person who supposes that he is protected by the darkness is vain, since he cannot escape the light that shines in the darkness, and the darkness grasped it not. Accordingly, he is discovered like a fugitive and a wicked hireling and is recognized before he can conceal himself. For all things are known to the Lord before he seeks them out, not only past events but also those that are to come. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB AND ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID 1.3.6.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN307",
      "id": "ap_NFIN307-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HASED BY THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZIANZUS: ")]), _vm._v("The light shines in darkness, in this life and in the flesh, and is chased by the darkness but is not overtaken by it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN308",
      "id": "ap_NFIN308-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" By this I mean the adverse power leaping up in its shamelessness against the visible Adam but encountering God and being defeated—in order that we, putting away the darkness, may draw near to the Light and may then become perfect Light, the children of perfect Light. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTS, ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATION 39.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN309",
      "id": "ap_NFIN309-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES ON THE ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFENSIVE. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Christ, because of the benefit that follows for humankind, took our darkness on himself that by his power he might destroy our death"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN310",
      "id": "ap_NFIN310-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" and completely destroy the darkness in our soul so that what Isaiah said might be fulfilled: “The people who sat in darkness have seen a great light.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN311",
      "id": "ap_NFIN311-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This light, indeed, that was made in the Word, which also is life, “shines in the darkness” of our souls. It has come to stay where the world rulers of this darkness live."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN312",
      "id": "ap_NFIN312-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" They by wrestling with the human race struggle to subject those who do not stand firm in every manner to darkness. He comes that, when they have been enlightened, they may be called children of light. And this light shines in the darkness and is pursued by it, but it is not overcome….")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The darkness pursued this light, as is clear from what our Savior and his children suffer. The darkness fighting against the children of light wanted to chase the light away. However, if “God is for us,” no one will be able to be “against us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN313",
      "id": "ap_NFIN313-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v("…")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now there are two ways that the darkness did not overcome the light. The darkness is either left very far behind it and, because it is slow, cannot keep up with the swiftness of the flight of light even to a limited extent, or, perhaps the light wanted to set an ambush for the darkness and awaited its approach and when the darkness drew near the light it was destroyed. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 2.166-70.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN314",
      "id": "ap_NFIN314-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANNOT ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPREHEND THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("“Darkness” is what John calls the nature that lacks illumination, that is, the whole originate nature…. For such a nature produces nothing on its own. Instead, it receives its whole being and well-being, such as it is, from its creator. This is why Paul says, “What do you have that you did not receive?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN315",
      "id": "ap_NFIN315-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" And since, along with the rest, it receives its light from God, not possessing it on its own, it receives it. But that which does not have light of itself cannot be called anything but “darkness.” The fact that “the Light shines in darkness” is a credible demonstration (in fact, one following from very necessity) that the creation is “darkness” while the Word of God is “Light.” For if the nature of things originate receives the Word of God by participation, as Light, or as of Light, it receives it then since it is inherently darkness, and the Son “shines in it” as “the light” shines in “darkness,” even though the darkness has no idea of the light’s existence. For this, I suppose, is the meaning of “the darkness did "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("not comprehend it.” For the Word of God shines upon all things that are receptive to his radiance and illumines without exception things that have a nature that is receptive to being illumined. But [the Word of God] is unknown by “the darkness.” For that which is the rational nature upon earth, I mean "), _c('i', [_vm._v("humanity")]), _vm._v(", “served the creature more than the Creator: it did not comprehend the Light,”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN316",
      "id": "ap_NFIN316-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" for it did not know the Creator, the fountain of wisdom, the beginning of understanding, the root of sense. Nevertheless, because of his love for humankind, things originate possess the light and are provided with the power of perception implanted concurrently with their passing into being. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 1.7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN317",
      "id": "ap_NFIN317-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLOGUE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGRAVED IN ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLD IN ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERY ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("The old saint Simplicianus, afterwards bishop of Milan, used to tell me that a certain Platonist was in the habit of saying that this opening passage of the holy Gospel, entitled “According to John,” should be written in letters of gold and hung up in all churches in the most conspicuous place. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 10.29.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN318",
      "id": "ap_NFIN318-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 84
// module chunks = 0